import React, { createContext, useEffect, useContext } from "react";
import axiosInstance from "../utils/AxiosInstance";
import useShowAlert from "../utils/AlertUtiles";
import { setData } from "../utils/CookieUtiles";
import handleError from "../constant/handleError";


const AuthContext = createContext();

export const AuthProvider = ({ children,loggedIn }) => {

  const showAlert = useShowAlert();

  useEffect(() => {  
    if (!loggedIn) return; 
 
     const authToken = async () => {
      try {
        const response = await axiosInstance.get("ownerauth/auth-token");
        const result = response.data.results;
        setData("Role", result.role);
        setData("NAME", result.name);
        setData("User_Name", result.username);
      } catch (error) {
        handleError(error, showAlert);
      }
    };
     authToken();  
  }, [loggedIn]);

 
  const value = {  };

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
